import { CommandResult, errorCodes } from "../../DTOs";
import { activityFieldValidation } from "./fields/activityFieldValidation";
import { actionPlanFieldValidation } from "./fields/actionPlanFieldValidation";
import { actionPointFieldValidation } from "./fields/actionPointFieldValidation";
import { locationFieldValidation } from "./fields/locationFieldValidation";
import { fileFieldValidation } from "./fields/fileFieldValidation";
import { surveyValidation } from "./fields/surveyFieldValidation";
import { courseFieldValidation } from "./fields/courseFieldValidation";
import { userFieldValidation } from "./fields/userFieldValidation";
import { miscFieldValidation } from "./fields/miscFieldValidation";
import { safetyInspectionFieldValidation } from "./fields/safetyInspectionFieldValidation";
import { customFormValidation } from "./fields/customFormValidation";
import { articleValidation } from "./fields/articleValidation";
import { externalLinkFieldValidation } from "./fields/externalLinkFieldValidation";
import { fileFolderValidation } from "./fields/fileFolderValidation";
import { referenceLinkFieldValidation } from "./fields/referenceLinkFieldValidation";
import { incidentFieldValidation } from "./fields/incidentFieldValidation";
import { uploadSlotFieldValidation } from "./fields/uploadSlotFieldValidation";
import { portalSharedResourceFieldValidation } from './fields/portalSharedResourceFieldValidation';


export class FieldValidation {

    public result: CommandResult;

    constructor() {
        this.result = CommandResult.succeeds();
    }

    public validate(isValid: boolean, error: errorCodes) {
        if (this.result.isSuccess) {
            this.result = isValid ? CommandResult.succeeds() : CommandResult.fails(error);
        }
        return this;
    }
}

export class FieldValidator {
    constructor(
        public isSuccess: boolean,
        public errorMessage: errorCodes
    ) { }

    validate(isValid: boolean, error: errorCodes): FieldValidator {
        // Only proceed if valid so far - stops at first failure
        if (this.isSuccess) {
            if (!isValid) {
                return new FieldValidator(false, error);
            }
            else
                return new FieldValidator(true, error);
        }
        else
            return this;
    }

    static validate(isValid: boolean, error: errorCodes): FieldValidator {
        return new FieldValidator(isValid, error);
    }

    result(): CommandResult {
        return this.isSuccess
            ? CommandResult.succeeds()
            : CommandResult.fails(this.errorMessage);
    }
}

export function validateFields(validationResults: CommandResult[]) {
    const firstFailure = validationResults.find(r => !r.isSuccess);
    if (firstFailure)
        return firstFailure;

    return CommandResult.succeeds();
}

export const fieldValidation = {

    ...activityFieldValidation,

    ...actionPlanFieldValidation,

    ...actionPointFieldValidation,

    ...articleValidation,

    ...locationFieldValidation,

    ...fileFieldValidation,

    ...surveyValidation,

    ...courseFieldValidation,

    ...userFieldValidation,

    ...miscFieldValidation,

    ...safetyInspectionFieldValidation,

    ...customFormValidation,

    ...externalLinkFieldValidation,

    ...fileFolderValidation,

    ...referenceLinkFieldValidation,

    ...incidentFieldValidation,

    ...uploadSlotFieldValidation,

    ...portalSharedResourceFieldValidation
    
}